'use client';
import { useEffect, useState } from 'react';
import getGeoLocation from './getGeoLocation';
import type { UseLocationContextArgs, UseLocationContextReturn } from './type';

export default function useGeoLocationContext({
  isGeoLocationTrackingEnabled,
}: UseLocationContextArgs): UseLocationContextReturn {
  const [isLoadingGeoLocation, setIsLoadingGeoLocation] = useState(false);
  const [geoLocation, setGeoLocation] = useState<UseLocationContextReturn['geoLocation'] | null>();

  useEffect(() => {
    async function getCurrentLocation() {
      if (!isGeoLocationTrackingEnabled) return;
      setIsLoadingGeoLocation(true);
      const geoLocationData = await getGeoLocation();

      if (geoLocationData) setGeoLocation(geoLocationData);
      setIsLoadingGeoLocation(false);
    }

    /**
     * donot call this function by default here,
     * only call it when the user explicitly requests the location when `Update Geolocation` action is called
     */
    // void getCurrentLocation();
  }, [isGeoLocationTrackingEnabled]);

  return { geoLocation, isLoadingGeoLocation };
}
